import { api } from "../../../shared";

const url = "/api/notes";

async function getByInventoryId(itemId) {
  return api
    .inventar({
      method: "get",
      url: `${url}/inventory/${itemId}`,
    })
    .then((response) => response.data);
}

async function create({ inventoryId, text }) {
  return api
    .inventar({
      method: "post",
      url,
      data: { inventory_id: Number(inventoryId), text },
    })
    .then((res) => res.data);
}

export const NotesService = {
  getByInventoryId,
  create
};
